import { BreakpointSizes } from './theme.types'

export const breakpoints = [1024, 1440]

export const breakpointsMap = {
  [BreakpointSizes.MEDIUM]: `${breakpoints[0]}px`,
  [BreakpointSizes.LARGE]: `${breakpoints[1]}px`,
}
